import React from 'react';
import './styles.less';
const Select = (props) => {
    return (
        <select {...props} className={`hms-select ${props.className}`}>{props.children}</select>
    )
}

export const Option = (props) => {
    return (
        <option {...props} className={`hms-select-option ${props.className}`}>{props.children}</option>
    )
}

export default Select;